import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { AuthAPI } from "../../../apis/AuthAPI";

export const authenticate = createAsyncThunk(
  "auth/authenticate",
  async (params: any = null, { getState, rejectWithValue }) => {
    var response = { token: null, me: null };
    try {
      const responseAuth = await AuthAPI.authorize(
        params.username,
        params.password
      );
      const responseMe = await AuthAPI.me(responseAuth.token);
      if(responseMe.data){
        response = { token: responseAuth.token, me: responseMe.data };
      }
      else{
        response = { token: null, me: null };
      }
    } catch (e: any) {
      console.log(`Error authenticate::createAsyncThunk ${e}`);
      return rejectWithValue({
        code: "FETCH_ERROR",
        message: 'Sessão expirada',
      });
    }
    return response;
  }
);

export const addAuthenticateReducers = (
  builder: ActionReducerMapBuilder<any>
) => {
  builder
    .addCase(authenticate.pending, (state, _action) => {
      localStorage.removeItem("token");
      state.me = null;
      state.token = null;
      state.errorMessage = null;
      state.loading = true;

      state.logged = false;
    })
    .addCase(authenticate.fulfilled, (state, action) => {
      const me: any = action.payload.me;
      localStorage.setItem("token", action.payload.token || "");
      state.me = me;
      state.token = action.payload.token;
      state.errorMessage = null;
      state.loading = false;

      state.logged = true;
      state.status = me.status ?? "CREATED";
    })
    .addCase(authenticate.rejected, (state, action: any) => {
      localStorage.removeItem("token");
      state.me = null;
      state.token = null;

      state.errorMessage = action.payload.message ?? "UNDEFINED_REJECTION";
      state.loading = false;
      state.logged = false;
    });
};
